export * from './appearance'
export * from './brand'
export * from './championship'
export * from './draft'
export * from './feud'
export * from './generic'
export * from './production'
export * from './reign'
export * from './segment'
export * from './setting'
export * from './show'
export * from './wrestler'

import { AppearanceItem } from './appearance'
import { BrandItem } from './brand'
import { ChampionshipItem } from './championship'
import { DraftItem } from './draft'
import { FactionItem } from './faction'
import { FeudItem } from './feud'
import { GenericItem } from './generic'
import { ProductionItem } from './production'
import { ReignItem } from './reign'
import { SegmentItem } from './segment'
import { SettingItem } from './setting'
import { ShowItem } from './show'
import { WrestlerItem } from './wrestler'

export const ListItems = {
  DEFAULT: GenericItem,
  APPEARANCE: AppearanceItem,
  BRAND: BrandItem,
  CHAMPIONSHIP: ChampionshipItem,
  DRAFT: DraftItem,
  FACTION: FactionItem,
  FEUD: FeudItem,
  REIGN: ReignItem,
  PRODUCTION: ProductionItem,
  SEGMENT: SegmentItem,
  SETTING: SettingItem,
  SHOW: ShowItem,
  WRESTLER: WrestlerItem
}

export const getListItemComponent = (key = ListItems.DEFAULT) => {
  return ListItems[key.toUpperCase()]
}

export default ListItems
